<script setup lang="ts">
import FooterItem from '@fondof-ui/components/footer/FooterItem.vue'
import FooterList from '@fondof-ui/components/footer/FooterList.vue'
import type { NavigationItemsCollectionItem } from '@fondof-ui/types'

const props = defineProps<{
  items: NavigationItemsCollectionItem[]
}>()
</script>
<template>
  <div
    class="row-start-5 md:col-start-[second-col] md:col-end-[last-col] md:row-start-[second-row] md:justify-self-end"
  >
    <FooterItem disabled>
      <template #content>
        <FooterList
          :items="props.items"
          direction="row"
        />
      </template>
    </FooterItem>
  </div>
</template>
